export default "__VITE_ASSET__5062c72e__"